<template>
  <div class="login-wrapper">
    <div class="login">
      <h1>Welkom</h1>

      <input @keydown.enter="login" @focus="focussedElement='userName'" v-model="userName" class="form-control" :placeholder="'Username'"/>
      <input   @keydown.enter="login" @focus="focussedElement='password'"  v-model="password" class="form-control" type="password" :placeholder="'Password'"/>
      <button @click="login" class="btn btn-primary" type="submit">
        Login
      </button>

      <div v-if="error" class="error">Onjuiste inloggegevens</div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {auth} from '../mixins/auth';

export default {
  name: 'login',
  data() {
    return {
      userName: '',
      password: '',
      focussedElement: null,
      error: null
    }
  },
  mixins: [auth],
  components: {},
  computed: {},
  async beforeDestroy(){
    console.log('destroy')
    await this.$barcodeScanner.barCodeEventBus.$off('barcodeScanned', this.barcodeScanned);

  },
  async beforeRouteLeave(from, to, next) {
    await this.$barcodeScanner.barCodeEventBus.$off('barcodeScanned', this.barcodeScanned);
    next();
  },
  created() {
    console.log('created')
    this.$barcodeScanner.barCodeEventBus.$on('barcodeScanned', this.barcodeScanned);
  },
  methods: {
    barcodeScanned(barcode) {
      if(!this.focussedElement) {
        return;
      } else {
        this[this.focussedElement] = barcode;
      }

    },
    async login() {

      const userName = `${this.userName}@heuvellogistiek.nl`;
      const password = `${this.userName.toLowerCase()}@${this.password}`;

      console.log("LOGIN",{userName, password})
      this.initFireBase(userName, password).then(() => {
        // this.$router.push({name: 'home'});
      }).catch(e => {
        this.error = e;
        console.error(e);
      });
    },
    mounted(){

    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  display: grid;
  grid-template-rows: auto 1fr 1fr 1fr;
  grid-row-gap: 1rem;
  width: 80%;
}

.login-wrapper {
  display: grid;
  height: 100vh;
  width: 100vw;
  justify-items: center;
  align-items: center;
}

.error {
  border: 1px solid red;
  padding: 12px;
  color: red;
  background: white;
  font-weight: bolder;
}
</style>